import React from "react";
import { ContactEmailModel, CustomerModel } from "@attelas/shared";
import { Chip, Grid2 as Grid, Typography } from "@mui/material";

type Props = {
  contactDetails: ContactEmailModel[];
};

const ContactDetails = ({ contactDetails }: Props) => {
  console.log(contactDetails);
  return (
    <Grid container={true} alignItems="center" justifyContent="end" flexWrap="nowrap" sx={{ minWidth: 0 }}>
      <Grid mr={0.5} sx={{ minWidth: 0 }} gap={0.5} container>
        {contactDetails.map((contact) => (
          <Chip
            key={contact.email}
            label={
              <Typography variant="body1" fontWeight={600} fontSize="12px">
                {contact.email}
              </Typography>
            }
            size="small"
            sx={{
              maxWidth: "100%",
              height: "auto",
              "& .MuiChip-label": {
                display: "block",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                paddingY: "2px",
              },
            }}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default ContactDetails;
